<template>
    <div>
        <img @click.prevent="imageIndex = 0" class="thumbnail" :src="imageURL(record.image_url)" />

        <CoolLightBox :items="galleryImages" :index="imageIndex" @close="imageIndex = null">
        </CoolLightBox>
    </div>
</template>

<script>
import { imageURL } from "@/mixins/imageURL.js";
export default {
    props: ["record"],
    mixins: [imageURL],
    created() {
        this.galleryImages[0] = this.imageURL(this.record.image_url);
    },
    data() {
        return {
            imageIndex: null,
            galleryImages: [],
        };
    },
};
</script>

<style lang="scss" scoped>
.thumbnail {
    max-width: 100%;
    margin-bottom: 10px;
    border-radius: $radius;
}
</style>
